// extracted by mini-css-extract-plugin
export var button = "_c7-4";
export var hasDarkBackground = "_c7-7";
export var hasLightBackground = "_c7-6";
export var iconWrapper = "_c7-0";
export var large = "_c7-2";
export var medium = "_c7-1";
export var small = "_c7-5";
export var xsmall = "_c7-3";